import { post } from '../api/baseUrl';
import { DashboardUser } from '../lib/transferObjects';

export interface UserAccessData {
  registered: boolean;
  userStatus: number;
  message?: string;
  data?: DashboardUser;
  error?: boolean;
}

let accessPromise: Promise<any> | null = null;

export const resetAccessCache = () => {
  accessPromise = null;
};

export const getUserAccess = async (
  force: boolean = false,
): Promise<UserAccessData> => {
  if (force) {
    accessPromise = null;
  }

  if (!accessPromise) {
    // We catch and re-throw so that if the promise fails, we clear the cache
    // allowing a subsequent retry to trigger a new request.
    accessPromise = post('getUserAccess', {}).catch((e) => {
      accessPromise = null;
      throw e;
    });
  }

  try {
    const access = await accessPromise;

    if (access?.message === 'Network Error') {
      return {
        registered: false,
        userStatus: 0,
        message: 'Network Error',
        error: true,
      };
    }

    return {
      registered: access?.data?.data?.registered,
      userStatus: access?.data?.data?.user_status,
      // Return the full data object so consumers (like LoggedInUserContext) can use it
      data: access?.data?.data,
    };
  } catch (e) {
    console.error('Error in getUserAccess:', e);
    return {
      registered: false,
      userStatus: 0,
      error: true,
    };
  }
};
